import * as React from "react"
import View from "./admin-account-theme-editor-component"
import {findScenarioAccountThemeByServices} from "../../../domain/sfp/scenario-domain";
import {updateAccountThemeComment, deleteAccountThemeComment} from "../../../service/sfp/scenarii-service";
import NotificationLevel from "../../notification"
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import * as actionCreators from '../../../action-creators'

class AdminAccountThemeEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            comment: null,
            loading: false,
            viewComment: false
        }
    }

    componentDidMount() {
        const scenarioTheme = this.props.themes && this.props.themes.length ? this.props.themes[this.props.col - 3] : null
        const scenarioAccountTheme = scenarioTheme ? findScenarioAccountThemeByServices(this.props.scenario.themes, scenarioTheme, this.props.row.account) : null
        const comment = scenarioAccountTheme && scenarioAccountTheme.comment ? scenarioAccountTheme.comment : ""
        this.setState({comment})
    }

    render() {
        const account = this.props.row.account
        const scenarioTheme = this.props.themes && this.props.themes.length ? this.props.themes[this.props.col - 3] : null
        const scenarioAccountTheme = scenarioTheme ? findScenarioAccountThemeByServices(this.props.scenario.themes, scenarioTheme, account) : null
        const comment = scenarioAccountTheme && scenarioAccountTheme.comment ? scenarioAccountTheme.comment : ""
        const title = comment ? "Modifier le commentaire" : "Ajouter un commentaire"
        const previousScenarii = []
        this.props.row.scenarii.filter(s => s.year < this.props.row.scenario.year).map(s => {
            s.scenarii.map(sc => {
                if (sc.validated) previousScenarii.push(sc)
            })
        })
        var previousValues = [], themeValue
        if (previousScenarii.length) {
            previousScenarii.map(s => {
                if (this.props.value && this.props.value.theme) {
                    if (account) {
                        if (themeValue = s.themes.find(t => t.account_id == account.id && t.theme_id == this.props.value.theme.id)) {
                            previousValues.push({year: s.year, value: themeValue})
                        }
                    } else if (this.props.row.chapter) {
                        var accounts = s.themes.filter(t => (t.theme_id == this.props.value.theme.id && (this.props.row.accountIds.indexOf(t.account_id) !== -1) && t.receipts == this.props.row.chapter.receipts))
                        var value = 0
                        accounts.map(a => {
                            value += a.amount
                        })
                        previousValues.push({
                            year: s.year,
                            value: {amount: value}
                        })
                    }
                }
            })
        }

        previousValues = previousValues.sort((a, b) => {
            return (a > b) ? 1 : -1
        })
        return (
            <View
                chapter={this.props.row.chapter}
                comment={this.state.comment}
                account={this.props.row.account}
                value={this.props.value}
                loading={this.state.loading}
                previousValues={previousValues}
                onChangeComment={this._onChangeComment}
                onClickDeleteComment={this._onClickDeleteComment}
                onClickCloseComment={this._onClickCloseComment}
                onClickViewComment={this._onClickViewComment}
                onSubmit={this._onSubmit}
                title={title}
                viewComment={this.state.viewComment}
            />
        )
    }


    _onClickCloseComment = () => {
        this.setState({viewComment: false})
    }

    _onClickDeleteComment = () => {
        const account = this.props.row.account
        const scenario = this.props.scenario
        const scenarioTheme = this.props.themes && this.props.themes.length ? this.props.themes[this.props.col - 3] : null
        const receipts = this.props.currentTab
        const comment = ""

        this.setState({loading: true})
        deleteAccountThemeComment(scenario, account, scenarioTheme, comment, receipts)
            .then(
                this._resolveDelete,
                this._rejectDelete
            )
    }

    _onClickViewComment = () => {
        this.setState({viewComment: !this.state.viewComment})
    }

    _onSubmit = (/** @type {React.SyntheticEvent<Element>} */ event) => {
        event.preventDefault()
        const form = event.target;
        const formData = new FormData(form);
        const comment = formData.get('comment');
        const account = this.props.row.account
        const scenario = this.props.scenario
        const scenarioTheme = this.props.themes && this.props.themes.length ? this.props.themes[this.props.col - 3] : null
        const accountTheme = findScenarioAccountThemeByServices(scenario.themes, scenarioTheme, account)

        if (accountTheme && accountTheme.comment && (accountTheme.comment === comment)) return this._onClickCloseComment()

        this.setState({loading: true})
        updateAccountThemeComment(scenario, account, scenarioTheme, comment, this.props.currentTab == "revenues")
            .then(
                this._resolveSubmit.bind(this, comment),
                this._rejectSubmit
            )
    }

    _resolveSubmit = (comment) => {
        this.setState({comment, loading: false})
        this._onClickCloseComment()
        this.props.actions.notify(
            NotificationLevel.Success,
            `Le commentaire a bien été ajouté ou modifié.`
        )
        this.setState({loadingPpi: false, ppiLoaded: true})
    }

    _rejectSubmit = (error) => {
        this.setState({loading: false, comment: this.state.comment})
        this.props.actions.notify(
            NotificationLevel.Danger,
            `Le commentaire n'a pas pu être ajouté ou modifié.`,
            error
        )
    }

    _resolveDelete = () => {
        this.setState({comment: null, loading: false})
        this._onClickCloseComment()
        this.props.actions.notify(
            NotificationLevel.Success,
            `Le commentaire a bien été supprimé.`
        )
    }

    _rejectDelete = (error) => {
        this.setState({loading: false, comment: this.state.comment})
        this.props.actions.notify(
            NotificationLevel.Danger,
            `Le commentaire n'a pas pu être supprimé.`,
            error
        )
    }
}

const mapStateToProps = state => state;
const mapDispatchToProps = (dispatch) => (
    {actions: bindActionCreators(actionCreators, dispatch)}
);

export default connect(mapStateToProps, mapDispatchToProps)(AdminAccountThemeEditor);



// WEBPACK FOOTER //
// ./src/component/scenarii/admin/admin-account-theme-editor-container.js